package one.healthium.insights.ui.shopping_list.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import one.healthium.insights.ui.shopping_list.models.ShoppingItemUiModel
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black10
import org.jetbrains.compose.resources.painterResource

@Composable
internal fun ShoppingItem(
    modifier: Modifier,
    uiModel: ShoppingItemUiModel,
    onClick: () -> Unit,
) {
    Row(
        modifier = modifier
            .padding(horizontal = 12.dp)
            .fillMaxWidth()
            .background(AppTheme.colors.surface, AppTheme.shapes.large)
            .clip(AppTheme.shapes.large)
            .clickable { onClick() }
            .padding(horizontal = 12.dp, vertical = 9.dp),
        verticalAlignment = Alignment.Companion.CenterVertically,
    ) {
        if (uiModel.emoji != null) {
            Box(
                modifier = Modifier.Companion
                    .size(36.dp)
                    .background(black10, CircleShape),
                contentAlignment = Alignment.Companion.Center,
            ) {
                Text(
                    text = uiModel.emoji,
                    style = AppTheme.textStyles.secondary_17_500,
                )
            }
        }
        Spacer(Modifier.Companion.width(12.dp))
        Column(Modifier.Companion.weight(1f)) {
            Text(
                text = uiModel.name,
                style = AppTheme.textStyles.secondary_17_500,
                color = AppTheme.colors.text100,
                maxLines = 1,
                overflow = TextOverflow.Companion.Ellipsis,
            )
            Spacer(Modifier.Companion.height(6.dp))
            Text(
                text = uiModel.quantity,
                style = AppTheme.textStyles.secondary_14_400,
                color = AppTheme.colors.text400,
                maxLines = 1,
                overflow = TextOverflow.Companion.Ellipsis,
            )
        }
        Spacer(Modifier.Companion.width(8.dp))
        Image(
            painter = if (uiModel.checked) painterResource(AppIcons.icCheckMarkChecked) else painterResource(AppIcons.icCheckMarkUnchecked),
            contentDescription = null,
        )
    }
}